import { Button } from "antd";
import * as React from "react";
import { PageSubheader } from "src/components/PageSubheader";

type PropsObjectCardHeader = {
  title: React.ReactNode;
  submitText: React.ReactNode;
  submitLoading?: boolean;
  submitHtmlType?: "button" | "reset" | "submit";
  onSubmitClick?: () => void;
  children?: React.ReactNode;
};

export const ObjectCardHeader: React.FC<PropsObjectCardHeader> = ({
  title,
  submitText,
  submitLoading,
  submitHtmlType,
  onSubmitClick,
  children,
}) => (
  <PageSubheader title={title}>
    <>
      {children}
      <Button
        type="primary"
        loading={submitLoading}
        htmlType={submitHtmlType}
        onClick={onSubmitClick}
      >
        {submitText}
      </Button>
    </>
  </PageSubheader>
);
